import { render, staticRenderFns } from "./CajaBancos.vue?vue&type=template&id=a6056182&scoped=true&"
import script from "./CajaBancos.vue?vue&type=script&lang=js&"
export * from "./CajaBancos.vue?vue&type=script&lang=js&"
import style0 from "./CajaBancos.vue?vue&type=style&index=0&id=a6056182&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6056182",
  null
  
)

export default component.exports